import { Link } from 'components/core-ui/Link'
import s from '../partners.modules.scss'
import { useParams } from 'react-router-dom'
import { useNotification } from 'hooks'
import { useLegalEntityQuery } from '../api'
import { useState } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { InfoItems } from 'components/core-ui/InfoItems'
import ActionComponents from '../components/ActionComponents'
import { NewLegalEntityModal } from '../LegalEntities/NewLegalEntityModal'
import { formatUIDate } from 'utils/helpers'
import { AssignmentsTable } from '../common/AssignmentsTable'
import { StoresTable } from './StoresTable'

const LegalEntity = () => {
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)

  const openEditModal = () => setIsEditModalOpen(true)
  const closeEditModal = () => setIsEditModalOpen(false)

  const { id } = useParams<{ id: string }>()

  const { showNotification } = useNotification()

  const {
    data: legalEntity,
    isLoading,
    refetch
  } = useLegalEntityQuery(showNotification, Number(id), shouldRefreshData)

  return (
    <div className={s.mainContainer}>
      {isLoading ? (
        <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
      ) : (
        <>
          <div className={s.breadcrumbsContainer}>
            <Link href="/iam/partners" className={s.breadcrumbsLink}>
              External Partners Management
            </Link>
            <span className={s.breadcrumbsSeparator}>|</span>
            <Link href="/iam/externalPartners/legalEntities" className={s.breadcrumbsLink}>
              Legal Entities
            </Link>
            <span className={s.breadcrumbsSeparator}>|</span>
            <span className={s.breadcrumbsCurrent}>
              {legalEntity?.code} - {legalEntity?.name}
            </span>
          </div>
          <NewLegalEntityModal
            isModalOpen={isEditModalOpen}
            closeModal={closeEditModal}
            setShouldRefreshData={setShouldRefreshData}
            editItem={legalEntity}
          />
          <Box className={s.flexContainer}>
            <Box className={s.infoItemsContainer}>
              <InfoItems
                itemsPerRow={2}
                itemsSpacing={2}
                items={[
                  { name: legalEntity.name, label: 'Name:' },
                  { name: legalEntity.isEnabled ? 'Enabled' : 'Disabled', label: 'Status:' },
                  { name: legalEntity.country.name, label: 'Country:' },
                  { name: legalEntity.activeAssignmentsCount, label: 'Assignments:' },
                  { name: legalEntity.code, label: 'CIF:' }
                ]}
                title="Legal entity details"
                actionComponents={<ActionComponents openEditModal={openEditModal} />}
              />
            </Box>
            <Box className={s.infoItemsContainer}>
              <InfoItems
                itemsPerRow={2}
                itemsSpacing={2}
                items={[
                  { name: legalEntity.createdBy, label: 'Created by:' },
                  { name: formatUIDate(legalEntity.createdDate), label: 'Created date:' },
                  { name: legalEntity.lastModifiedBy, label: 'Modified by:' },
                  {
                    name: formatUIDate(legalEntity.lastModifiedDate),
                    label: 'Modified date:'
                  }
                ]}
                title="Legal entity metadata"
              />
            </Box>
          </Box>
          <Box className={s.flexContainer} style={{width: '100%', display: 'block'}}>
            <AssignmentsTable legalEntityId={legalEntity.id} />
          </Box>
          <Box className={s.flexContainer}>
            <StoresTable legalEntityId={legalEntity.id} />
          </Box>
        </>
      )}
    </div>
  )
}

export default LegalEntity
